import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { firestore } from "../firebase";
import { mapDocToProject, Project, ProjectCollection } from "../types/Project";

export function useProject(projectId: string | null) {
  const [project, setProject] = useState<Project | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setIsLoading(false);
      setError("Project ID is missing");
      return;
    }

    setIsLoading(true);
    const unsubscribe = onSnapshot(
      doc(firestore, ProjectCollection, projectId),
      (doc) => {
        try {
          setProject(mapDocToProject(doc.id, doc.data()));
          setIsLoading(false);
          setError(null);
        } catch (err) {
          setError("Failed to load project details");
          setProject(null);
          setIsLoading(false);
        }
      },
    );

    return () => unsubscribe();
  }, [projectId]);

  return useMemo(
    () => ({ project, isLoading, error }),
    [project, isLoading, error],
  );
}
